module.exports = __webpack_public_path__ + "static/media/ks_crate.256fe530.png";